import { useLazyQuery } from '@apollo/client'
import moment from 'moment-jalaali'
import { useEffect, useState } from 'react'
import { toast } from 'react-toastify'

import { credentialsVar, loadingSessionStorage } from '../../cache/auth'
import { ME_QUERY } from '../../graphql/auth'
import { lang } from '../../localization'
import { Credentials, UserOTPCode, UserPhoneNumber } from '../../types/auth'
import UserInfo from './userInfo'
import VerifyNumber from './verifyNumber'
import VerifyOTPCode from './verifyOTPCode'

const Index = () => {
  const [input, setInput] = useState<UserPhoneNumber>({
    phoneNumber: ''
  })
  const [keepuserLoggedIn, setkeepuserLoggedIn] = useState(false)
  const [inputOTP, setInputOTP] = useState<UserOTPCode>({
    otpCode: '',
    keepMeLogedIn: false
  })
  const [step, setStep] = useState<number>(1)
  const [timeLeftInSeconds, setTimeLeftInSeconds] = useState<number>(180)

  const year = moment().format(lang === 'fa' ? 'jYYYY' : 'YYYY')

  const [getCredentials] = useLazyQuery<{
    me: Credentials
  }>(ME_QUERY, {
    // `me` takes no arguments, so this shares one cache entry with
    // useBootstrapSession's and pingSession's `me` queries. Both of those force
    // network-only; this one didn't, so a stale cached `me` (e.g. left over from a
    // session-expiry redirect that intentionally skips a full page reload) was served
    // straight from cache after a fresh login, showing the wrong user until the next
    // manual refresh forced a real fetch.
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true,
    onCompleted: (data) => {
      credentialsVar(data.me)
      loadingSessionStorage(false)
    },
    onError: (error) => {
      loadingSessionStorage(false)
      toast.error(error.message)
    }
  })

  useEffect(() => {
    setInputOTP({
      ...inputOTP,
      keepMeLogedIn: keepuserLoggedIn
    })
  }, [keepuserLoggedIn])

  switch (step) {
    case 1:
      return (
        <UserInfo
          year={year}
          setStep={setStep}
          setTimeLeftInSeconds={setTimeLeftInSeconds}
          keepuserLoggedIn={keepuserLoggedIn}
          setkeepuserLoggedIn={setkeepuserLoggedIn}
          getCredentials={getCredentials}
        />
      )
    case 2:
      return (
        <VerifyNumber
          input={input}
          setInput={setInput}
          year={year}
          setStep={setStep}
          setTimeLeftInSeconds={setTimeLeftInSeconds}
        />
      )
    case 3:
      return (
        <VerifyOTPCode
          inputOTP={inputOTP}
          setInputOTP={setInputOTP}
          year={year}
          timeLeftInSeconds={timeLeftInSeconds}
          setTimeLeftInSeconds={setTimeLeftInSeconds}
          step={step}
          setStep={setStep}
          getCredentials={getCredentials}
        />
      )

    default:
      return <div />
  }
}

export default Index
